import React, { Fragment } from 'react';
import Grid from '@material-ui/core/Grid';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Input from '@material-ui/core/Input';
import TextField from '@material-ui/core/TextField';
import basicsStyle from 'assets/jss/material-kit-pro-react/views/componentsSections/basicsStyle.jsx';
import 'react-confirm-alert/src/react-confirm-alert.css';
import _ from 'lodash-es';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { backEndTools } from './tools';
import { InputLabel, Box } from '@material-ui/core';

const ApiCard = React.forwardRef(
  (
    {
      handleChange,
      apiTool,
      apiAuthenticatedField,
      apiAccessibleField,
      apiDescription,
      apiArchitecture,
      apiDatastore,
      apiTestCasesError,
      apiEditorDescState,
      apiEditorTestDescState,
      onApiTestDescEditorStateChange,
      apiTestRefEditorDescState,
      onApiRefEditorStateChange,
      onApiDescEditorStateChange,
      handleApiAuthenticatedValidation,
      apiAuthenticatedFieldError,
      handleKeyDown,
    },
    ref
  ) => {
    return (
      <Fragment>
        <Grid item sm={12} md={12} lg={6}>
          <TextField
            id='select-story-type'
            name='apiTool'
            label='Programming Tools'
            select
            fullWidth
            margin='dense'
            value={apiTool}
            onChange={handleChange}
          >
            {backEndTools.map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='apiAuthenticatedField'
            label='Authenticated'
            fullWidth={true}
            margin='dense'
            value={apiAuthenticatedField}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='apiAccessibleField'
            label='Accessible by role'
            fullWidth={true}
            margin='dense'
            value={apiAccessibleField}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>API Description</InputLabel>
          <Box borderBottom={1}>
            <Editor
              editorState={apiEditorDescState}
              toolbarClassName='toolbarClassName'
              wrapperClassName={
                apiTestCasesError
                  ? 'editorWrapper editorRequiredError'
                  : 'editorWrapper'
              }
              editorClassName='editorClassName'
              onEditorStateChange={onApiDescEditorStateChange}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='apiArchitecture'
            label='Architecture requirements'
            fullWidth={true}
            margin='dense'
            value={apiArchitecture}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id='regular'
            name='apiDatastore'
            label='Datastore requirements'
            fullWidth={true}
            margin='dense'
            value={apiDatastore}
            onChange={handleChange}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={12}>
          <InputLabel>Test cases</InputLabel>
          <Box borderBottom={1}>
            <Editor
              editorState={apiEditorTestDescState}
              toolbarClassName='toolbarClassName'
              wrapperClassName={
                apiTestCasesError
                  ? 'editorWrapper editorRequiredError'
                  : 'editorWrapper'
              }
              editorClassName='editorClassName'
              onEditorStateChange={onApiTestDescEditorStateChange}
            />
          </Box>
        </Grid>
        <Grid item xs={12}>
          <InputLabel>API reference</InputLabel>
          <Box borderBottom={1}>
            <Editor
              editorState={apiTestRefEditorDescState}
              toolbarClassName='toolbarClassName'
              editorClassName='editorClassName'
              onEditorStateChange={onApiRefEditorStateChange}
            />
          </Box>
        </Grid>
      </Fragment>
    );
  }
);

export default ApiCard;
